const productId = product =>
  typeof product === 'string' ? product : product?._id

// A basket line whose product has gone can't be ordered, priced or grouped
// by supplier; Checkout already skips it. The basket endpoint still sends
// such a line with a stub `product: { price: null, OMSPrice: null }`.
export const isOrderableBasketLine = order =>
  Boolean(order && order._id && productId(order.product))

export const formatMinimumOrder = minimumOrderValue =>
  `Minimum order £${minimumOrderValue}`
